
import ActiveField from '@/components/ActiveCampaignFormNew/ActiveField';
import activecampaign from '@/services/activecampaign';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react'
import { Wrapper } from './styles'

interface NewsLetterProps {
  setShow: any;
}

const NewsLetter: React.FC<NewsLetterProps> = ({ setShow }) => {
  const [fieldsToCreate, setFieldsToCreate] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)

  const router = useRouter()

  const submit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const { EMAIL, NAME } = e.target.elements;

      const splittedName = NAME.value.split(' ');
      const firstName = splittedName[0];
      const lastName = splittedName[1];

      let fieldValues = Array.from(e.target.elements)
        .filter((el: any) => !el.dataset.default && el.type !== 'submit' && el.checked)
        .map((el: any) => ({
          field: el.dataset.field,
          value: el.value
        }))

      let field = {
        field: '50',
        value: ''
      }

      fieldValues.map(fieldValue => {
        if (fieldValue.field === '50') {
          field.value = `${field.value}${fieldValue.value},`
        }
      })

      fieldValues = [...fieldValues.filter(fieldValue => fieldValue.field !== '50'), field]

      const payload = {
        contact: {
          email: EMAIL.value,
          firstName,
          lastName,
          fieldValues,
        },
        tag: router.route === "/blog/[id]" ? 368 : 370,
      };

      await fetch('/api/activecampaign/contacts/', {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      setLoading(false);
      setSuccess(true)
    } catch (e) {
      setLoading(false);
      console.log(e)
    }
  };

  useEffect(() => {
    const getField = async (id) => {
      const { data } = await axios.get(`/api/activecampaign/fields/${id}`);

      return data;
    };

    const getInputs = async () => {
      const idToCreate = [50, 51];

      const customFieldsToCreate = await Promise.all(
        idToCreate.map(async (id) => getField(id))
      );
      
      setFieldsToCreate([
        customFieldsToCreate[0],
        {
          field: {
            isDefault: true,
            title: 'Nome',
            type: 'text',
            perstag: 'NAME',
            isrequired: '1'
          }
        },
        {
          field: {
            isDefault: true,
            title: 'E-mail',
            type: 'text',
            perstag: 'EMAIL',
            isrequired: '1',
            inputType: 'email'
          }
        },
        {
          ...customFieldsToCreate[1],
          field: {
            ...customFieldsToCreate[1].field,
            isrequired: '1'
          }
        },
      ])
    }

    getInputs()
  }, [])

  return (
    <Wrapper onSubmit={submit}>
      <FontAwesomeIcon icon={faTimes} onClick={() => {
        setShow(false)
      }} />

      {success ? (
        <>
          <p style={{
            fontWeight: 700,
            fontSize: 32,
            color: 'black',
            lineHeight: 1,
            textAlign: 'left',
            margin: 'unset'
          }}><span style={{
            textAlign: 'left',
            color: '#2253F5',
            fontWeight: 700,
            fontSize: '32px',
            display: 'inline'
          }}>Obrigado!</span> Enviamos a confirmação da inscrição para o seu e-mail.</p>
          <span  style={{
            textAlign: 'left',
            fontWeight: 700,
            fontSize: 32,
            color: 'black',
            lineHeight: 1
          }}>Agradecemos sua inscrição e esperamos que você aproveite nossos conteúdos!</span>
        </>
      ) : (
        <>
          <p>Inscreva-se em nossa newsletter</p>

          <span >Que assuntos você quer receber?</span>

          {fieldsToCreate.map((field) => (
            <ActiveField field={field} key={field?.field?.id} />
          ))}

          <button disabled={loading} type='submit'>{loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Assinar newsletter'}</button>
        </>
      )}
    </Wrapper>
  )
}

export default NewsLetter